export default __webpack_public_path__ + "static/media/proj13-cover.b82476ad.png";